import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalsComponent } from "../../../../modules/layout/modals/modals.component";
import {
  environment as params,
  environment
} from "src/environments/environment";
import { ModalComponent } from "../../../layout/modal/modal.component";
declare var $: any;

@Component({
  selector: "app-web-product",
  templateUrl: "./web-product.component.html",
  styleUrls: ["./web-product.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class WebProductComponent implements OnInit {
  @Input() internacional: any;
  @Input('product') product: any;
  @Input('products') products;
  @Output('selected') selected: EventEmitter<any> = new EventEmitter<any>();
  @Output('selectCardProd') selectCardProd = new EventEmitter<any>();
  @Output('toPayment') payment: EventEmitter<any> = new EventEmitter<any>();
  public dataTable: any;
  @ViewChild('modal') modal: ModalsComponent;
  public togglePipe: boolean = false;
  public loader: boolean = false;
  public statusRead: boolean = false;
  urlBaseMJ: any = (<any>params).api.mj;

  slickOptions: any = {
    initialSlide: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    centerMode: false,
    responsive: []
    //   prevArrow: '<div class="slick-prev"></div>',
    //   nextArrow: '<div class="slick-next"></div>'
  };

  constructor(private modalService: NgbModal) {
    this.dataTable = JSON.parse(localStorage.getItem('planes'));
  }

  ngOnInit() { }

  /**
   * @description Desplegar modal con los detalles del addOn
   * @param content JSON del addOn
   */
  showDetails(content) {
    this.modal.openModal(content);
  }

  /**
   * @description Función para seleccionar el plan, impacta sobre este componente y sobre el componente <app-web-table>
   * @param id Id del plan seleccionado
   * @param mobile Está en mobile?
   */
  selectProduct(id, product, mobile = false) {
    if (sessionStorage.getItem('product')) {
      localStorage.removeItem('product');
      sessionStorage.setItem('product', JSON.stringify(product));
    } else {
      sessionStorage.setItem('product', JSON.stringify(product));
    }

    this.togglePipe = !this.togglePipe;

    let n =
      this.product.vouchers.filter(p => Number(p.productId === id)).length > 0
        ? this.product.vouchers.filter(p => Number(p.productId === id))[0]
        : '';
    switch (n.productType.toLowerCase()) {
      case 'univ':
        n = 10;
        break;
      case 'april':
        n = 4;
        break;
      case 'budget':
        n = 8;
        break;
      case 'elite':
        n = 4;
        break;
      case 'mexico':
        n = 6;
        break;
      case 'super':
        n = 2;
        break;
    }

    //CERRAR resto de collapse
    var collaps = document.getElementsByClassName("collapseExtras");
    let cId = "collapse-" + id;
    for (var i = 0; i < collaps.length; ++i) {
      if (!collaps[i].id.includes(cId)) {
        collaps[i].classList.remove("show");
      }
    }

    //Seleccionar producto mobile
    if (!mobile) {
      var element = document.getElementsByClassName("product");
      for (var i = 0; i < element.length; ++i) {
        element[i].classList.remove("selected");
      }

      var d = document.getElementById("p-" + id);
      d.className += " selected";
    }

    //Seleccionar producto mobile
    if (mobile) {
      var element = document.getElementsByClassName("product-mobile");
      for (var i = 0; i < element.length; ++i) {
        const idElement = Number(
          element[
            i
          ].children[0].children[0].children[1].children[0].children[0].children[0].id.split(
            "-"
          )[1]
        );
        if (
          element[i].children[0].children[0].children[1].children[0].children[0]
            .children[0].lastElementChild.children[0].innerHTML == "Comprar" &&
          idElement == id
        ) {
          this.next();
        }
        if (element[i].children[0].children[0].children.length === 3) {
          element[
            i
          ].children[0].children[0].children[1].children[0].children[0].children[0].classList.remove(
            "selected"
          );
          element[
            i
          ].children[0].children[0].children[1].children[0].children[0].children[0].lastElementChild.children[0].innerHTML =
            "Elegir";
        } else {
          element[
            i
          ].children[0].children[0].children[0].children[0].children[0].children[0].classList.remove(
            "selected"
          );
          element[
            i
          ].children[0].children[0].children[0].children[0].children[0].children[0].lastElementChild.children[0].innerHTML =
            "Elegir";
        }
      }
      var d = document.getElementById("pm-" + id);
      d.className += " selected";
      setTimeout(() => {
        d.lastElementChild.children[0].innerHTML = "Comprar";
      }, 100);
    }

    //Seleccionar tabla
    var element2 = document.getElementsByClassName("columna");
    for (var i = 0; i < element2.length; ++i) {
      element2[i].classList.remove("bg-selected");
    }
    var d2 = document.getElementById("t-" + id);
    d2.className += " bg-selected";

    //Seleccionar celdas de tabla
    const element3 = document.getElementsByClassName('fila');
    for (let b = 0; b < element3.length; ++b) {
      $(element3[b].childNodes[1]).removeClass('bg-selected');
      $(element3[b].childNodes[2]).removeClass('bg-selected');
      $(element3[b].childNodes[3]).removeClass('bg-selected');
      $(element3[b].childNodes[4]).removeClass('bg-selected');
      $(element3[b].childNodes[5]).removeClass('bg-selected');
      $(element3[b].childNodes[6]).removeClass('bg-selected');
      $(element3[b].childNodes[7]).removeClass('bg-selected');
      $(element3[b].childNodes[8]).removeClass('bg-selected');
      $(element3[b].childNodes[9]).removeClass('bg-selected');
      $(element3[b].childNodes[10]).removeClass('bg-selected');
      $(element3[b].childNodes[n]).addClass('bg-selected');
    }

    //Seleccionar botón TABLA
    var element5 = document.getElementsByClassName('btn-select');
    for (var i = 0; i < element5.length; ++i) {
      element5[i].innerHTML = 'Elegir';
    }
    document.getElementById('btn-' + id).innerHTML = 'Comprar';
  }

  buyInsurance(insuranceSelected) {

    this.selected.emit({
      ...this.product,
      selectedProduct: insuranceSelected.vouchers[0]
    });
    /*
    if (!insuranceSelected.addons || insuranceSelected.addons.length === 0) {
      this.selected.emit({
        ...this.product,
        selectedProduct: insuranceSelected.vouchers[0]
      });
    } else {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
        //this.extraInsurance(insuranceSelected.vouchers[0]);
      }, 1500);
    }*/

    this.selectCardProd.emit(insuranceSelected);
  }

  extraInsurance(insuranceSelected) {
    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      windowClass: 'modal-info'
    });
    modalRef.componentInstance.typeModal = 'modalInfo';
    modalRef.componentInstance.title = '¿Deseas añadir extras a tu seguro?';
    modalRef.componentInstance.insuranceSelected = insuranceSelected;

    modalRef.result.then(
      resp => {
        if (resp.addOns) {
          this.selected.emit({ ...this.product, selectedProduct: resp });
        }
      },
      resp => {
        if (resp.productType === 'BUDGET') {
          const modalRefAceptUpdateSuper = this.modalService.open(ModalComponent,
            { centered: true, windowClass: 'modal-update-super' }
          );
          modalRefAceptUpdateSuper.componentInstance.typeModal =
            'modalChangeToSuper';
          modalRefAceptUpdateSuper.componentInstance.title =
            '¡Cámbiate al Plan Súper!';
          modalRefAceptUpdateSuper.componentInstance.subTitle =
            'Mejora tu cobertura y obtén grandes beneficios';

          modalRefAceptUpdateSuper.result.then(resp => {
            if (resp.updateTo !== '') {
              const _super = this.products.filter(({ productType }) => productType === resp.updateTo)[0];
              this.selected.emit({ ..._super });
            }
          });
        }
      }
    );
  }

  next() {
    this.payment.emit(true);
  }

  scrollToElement($element): void {
    if (!this.statusRead) {
      this.statusRead = true
    } else {
      this.statusRead = false
      console.log($element);
      $element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
}
